import React from 'react';

import { TabsTypes } from 'components/Tabs/types';
import { TabsStatic } from "components/Tabs/components/Tabs/Tabs";

interface ITabListProps {
  children: React.ReactElement,
  className: string
}

const TabList: React.FC<ITabListProps> & TabsStatic = (props) => {

  const {
    children,
    className
  } = props

  return (
    <ul className={className}>
      {children}
    </ul>
  )
}
TabList.tabsRole = TabsTypes.TabList;

export default TabList;